import { Store } from 'src/store/index';

const getIncludeDpiEnhancement = (store: Store) => store.design.includeDpiEnhancement;

export default getIncludeDpiEnhancement;
